module.exports = ".intro-card {\r\n    position: relative;\r\n    width: 80%;\r\n    margin: auto;\r\n}\r\n\r\n.search {\r\n    position: relative;\r\n    width: 80%;\r\n    margin: auto;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/search-bills/search-bills.component.css
// module id = ./src/app/search-bills/search-bills.component.css
// module chunks = main